var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MultiformListManager,{attrs:{"readonly":true,"value":_setup.households[0].borrowers,"itemName":_setup.I18NGetter().useSimulationFormStep2And3.BORROWER},scopedSlots:_vm._u([{key:"default",fn:function({item}){return [_c(_setup.SimulationFormStep3Wrapper,{attrs:{"borrower":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }